import Service from "./Service";

export default class AdditionalPayment extends Service {
    constructor() {
        super();
    }

    createAdditionalPayment(data) {
        return this.axios.post('/confirmation', data);
    }
}